<template>
    <section class="grid justify-center mb-4 mt-1" >
        <div class="flex items-center justify-end pb-2">
            <label for="description" class="w-40 text-right mr-2">Descripción</label>
            <InputText id="description" v-model="description" placeholder="Descripción de la factura" class="w-80" :disabled="formDisabled"/>
        </div>
        <div class="flex items-center justify-end pb-2">
            <label for="serial" class="w-40 text-right mr-2">Folio</label>
            <InputText id="serial" v-model="serial" placeholder="Folio de la factura" class="w-80" :disabled="formDisabled"/>
        </div>
        <div class="flex items-center justify-end pb-2">
            <label for="subtotal" class="w-40 text-right">Subtotal</label>
            <InputNumber id="subtotal" v-model="subtotal" placeholder="0.00" class="ml-2 w-80" currency="MXN" locale="es-MX" :maxFractionDigits="2" :disabled="formDisabled"/>
        </div>
        <div class="flex items-center justify-end pb-2">
            <label for="iva" class="w-40 text-right">IVA</label>
            <InputNumber id="iva" v-model="iva" placeholder="0.00" class="ml-2 w-80" currency="MXN" locale="es-MX" :maxFractionDigits="2" :disabled="formDisabled"/>
        </div>
        <div class="flex items-center justify-end pb-2">
            <label for="issue-date" class="w-40 text-right">Fecha de emisión</label>
            <Calendar id="issue-date" v-model="issueDate" showIcon :showOnFocus="false" class="ml-2 w-80" dateFormat="dd/mm/yy" :disabled="formDisabled"/>
        </div>
        <div class="flex items-center justify-end pb-2">
            <label for="company-name" class="w-40 text-right mr-2">Razón Social</label>
            <InputText id="company-name" v-model="companyName" placeholder="Razón Social" class="w-80" :disabled="formDisabled"/>
        </div>
        <div class="flex items-center justify-end pb-2">
            <label for="client" class="w-40 text-right">Cliente</label>
            <Dropdown id="client" v-model="selectedClient" :options="clients" optionLabel="name" placeholder="Selecciona un cliente"
            class="ml-2 w-80" filter :disabled="formDisabled"/>
        </div>
        <div class="flex items-center justify-end pb-2">
            <label for="invoice-type" class="w-40 text-right">Tipo</label>
            <Dropdown id="invoice-type" v-model="selectedInvoiceType" :options="invoiceTypes" optionLabel="name"
            placeholder="Selecciona un tipo de factura" class="ml-2 w-80" :disabled="formDisabled"/>
        </div>
        <div class="flex items-center justify-end pb-2">
            <label for="applies-commission" class="w-40 text-right mr-2">Aplica comisión</label>
            <ToggleButton id="applies-commission" v-model="appliesCommission" onIcon="pi pi-check" offIcon="pi pi-times" onLabel="Sí"
                aria-label="Aplica comisión" class="w-80" :disabled="formDisabled"/>
        </div>
        <div class="flex items-center justify-end pb-2" v-show="appliesCommission">
            <label for="company" class="w-40 text-right">Empresa</label>
            <Dropdown id="company" v-model="selectedCompany" :options="companies" optionLabel="name" placeholder="Selecciona una empresa"
            class="ml-2 w-80" @change="companyChange"/>
        </div>
        <div class="flex items-center justify-end pb-2" v-show="appliesCommission">
            <label for="branch" class="w-40 text-right">Sucursal</label>
            <Dropdown id="branch" v-model="selectedBranch" :options="selectedCompany.branches" optionLabel="name" placeholder="Selecciona una sucursal"
            class="ml-2 w-80" filter/>
        </div>
        <div class="flex items-center justify-end pb-2" v-show="appliesCommission">
            <label for="commission-percentage" class="w-40 text-right">Porcentaje de comisión (%)</label>
            <InputNumber id="commission-percentage" v-model="commissionPercentage" :useGrouping="false" placeholder="Especifica un porcentaje"
            class="ml-2 w-80" suffix="%"/>
        </div>
        <div class="mt-2">
            <Button id="record-btn" label="Registrar" @click="recordInvoice" :disabled="buttonDisabled"></Button>
        </div>
    </section>
</template>

<script>
    import axiosInstance from '../axiosInstance';
    export default {
        data() {
            return {
                formDisabled: false,
                buttonDisabled: false,
                description: "",
                serial: "",
                subtotal: null,
                iva: null,
                issueDate: new Date(),
                companyName: "",
                clients: [],
                selectedClient: {},
                invoiceTypes: [],
                selectedInvoiceType: {},
                appliesCommission: false,
                companies: [],
                selectedCompany: {},
                selectedBranch: {},
                commissionPercentage: null
            }
        },

        methods: {
            async fetchInitialData() {
                this.$emit("update-loading", true);
                this.formDisabled = true;
                this.buttonDisabled = true;
                let data = {};
                try {
                    const response = axiosInstance.post("/api/invoice_get", {
                        token: localStorage.getItem('token')
                    });

                    data = await response;
            
                } catch(error) {
                    console.error("fetchInitialData: There was an error!", error);
                    this.$toast.add({ severity: 'error', summary: 'Error',
                    detail: 'Hubo un problema al consultar los datos.', life: 5000, group: 'topr' });
                } finally {
                    this.$emit("update-loading", false);
                }

                return data;
            },

            setInitialData() {
                this.fetchInitialData().then((response) => {
                    if(response.status === 200) {
                        const { defaultCmp, companies, clients, types } = response.data;
                        
                        this.selectedCompany = {
                            name: defaultCmp.data.name, 
                            id: defaultCmp.data.id, 
                            branches: defaultCmp.branches
                        }

                        this.companies = companies.map((company) => {
                            return {
                                name: company.data.name,
                                id: company.data.id,
                                branches: company.branches
                            }
                        });

                        this.selectedBranch = this.selectedCompany.branches[0];
                        this.clients = clients;
                        this.selectedClient = this.clients[0];
                        this.invoiceTypes = types;
                        this.selectedInvoiceType = this.invoiceTypes[0];

                        this.formDisabled = false;
                        this.buttonDisabled = false;
                    } else {
                        console.warn("setInitialData: There was a problem with the request.", response);
                        this.$toast.add({ severity: 'warn', summary: 'Aviso',
                        detail: 'Hubo un problema con la solicitud. Vuelve a intentarlo.', life: 5000, group: 'topr' });
                    }
                })
            },

            async postInvoice(){
                this.$emit("update-loading", true);
                this.buttonDisabled = true;
                let data = {};
                try {
                    const request = {
                        serial_str: this.serial.trim(),
                        description: this.description.trim(),
                        subtotal: this.subtotal,
                        tax: this.iva,
                        invoice_period: this.formatDate(this.issueDate),
                        name: this.companyName.trim(),
                        client: this.selectedClient.id,
                        type: this.selectedInvoiceType.id,
                        token: localStorage.getItem('token')
                    };

                    if(this.appliesCommission){
                        request.commission_branch_id = this.selectedBranch.id,
                        request.commission_percentage = this.commissionPercentage ? this.commissionPercentage / 100 : 0;
                    }

                    const response = axiosInstance.post("/api/invoice_save", request);

                    data = await response;
            
                } catch(error) {
                    console.error("postInvoice: There was an error!", error);
                    this.$toast.add({ severity: 'error', summary: 'Error',
                    detail: 'Hubo un problema al consultar los datos.', life: 5000, group: 'topr' });
                } finally {
                    this.$emit("update-loading", false);
                    this.buttonDisabled = false;
                }

                return data;
            },

            recordInvoice() {
                this.postInvoice().then((response) => {
                    if(response.status === 200) {
                        if(response.data.error && response.data.message) {
                            const { message } = response.data;
                            this.$toast.add({ severity: 'warn', summary: 'Aviso',
                            detail: message, life: 5000, group: 'topr' });
                        } else {
                            this.$toast.add({ severity: 'success', summary: 'Éxito',
                            detail: 'Factura registrada correctamente.', life: 5000, group: 'topr' });
                            this.$router.push('/ver-facturas');
                        }
                    } else {
                        console.warn("recordInvoice: There was a problem with the request.", response);
                        this.$toast.add({ severity: 'warn', summary: 'Aviso',
                        detail: 'Hubo un problema con la solicitud. Vuelve a intentarlo.', life: 5000, group: 'topr' });
                    }
                });
            },

            companyChange() {
                this.selectedBranch = this.selectedCompany.branches[0];
            },

            formatDate(date){
                const month = ((date.getMonth()+1).toString()).padStart(2, "0");
                const day = ((date.getDate()).toString()).padStart(2, "0");
                return `${date.getFullYear()}-${month}-${day}`
            },
        },

        mounted() {
            this.setInitialData();
        },

        watch: {
            subtotal(newVal){
                this.iva = newVal ? newVal * 0.16 : 0;
            }
        }
    }
</script>

<style scoped>
    ::v-deep(.p-calendar .p-button) {
        @apply bg-zinc-200 text-zinc-900 border-zinc-300 hover:bg-zinc-300 dark:bg-zinc-700 dark:text-zinc-100 dark:border-zinc-600 dark:hover:bg-zinc-600 transition-colors;
    }
    ::v-deep(.p-calendar .p-button:hover) {
        @apply bg-zinc-300 dark:bg-zinc-600;
    }
    ::v-deep(.p-highlight) {
        @apply bg-zinc-300 !important;
    }
    ::v-deep(.p-highlight:hover) {
        @apply bg-zinc-400 !important;
    }
    #record-btn {
        @apply bg-zinc-200 text-zinc-900 border border-zinc-300 hover:bg-zinc-300 dark:bg-zinc-700 dark:text-zinc-100 dark:border-zinc-600 dark:hover:bg-zinc-600 rounded px-4 py-2 text-lg shadow focus:outline-none transition-colors;
    }
</style>